
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"15","height":"15","viewBox":"0 0 15 15"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M7.5 0c.255 0 .46.816.765 1.582.306.816.204 1.275.204 1.275v2.806l.919.561V6.02h-.102s-.051-.51-.051-.714v-.46c0-.101.102-.101.102-.101h.561c.051 0 .102.102.102.102s.051.153.051.51S10 6.02 10 6.02h-.102l-.051.409s3.112 1.836 3.418 1.99.255.305.255.305v.664L9.95 8.06H8.52v1.53c0 .511-.05.766-.05.766l-.46 2.755 1.633 1.327v-.408h.05V15l-1.989-.714-.153.714h-.102l-.153-.714-1.99.714v-.97h.051v.409l1.633-1.327-.46-2.755s-.05-.255-.05-.765v-1.53H5.05L1.48 9.387v-.664s-.051-.102.255-.306c.306-.153 3.418-1.99 3.418-1.99l-.051-.408H5s-.051-.306-.051-.663.051-.51.051-.51 0-.102.102-.102h.561s.102 0 .102.102v.46c0 .203-.05.713-.05.713h-.103v.204l.919-.56V2.856s-.051-.459.204-1.275C7.04.765 7.245 0 7.5 0z"}})])
          )
        }
      }
    